<app-besprechung-view class="mat-app-background-1"                      
                      [details]="detailsStore.besprechung$ | async"
                      [loading]="detailsStore.loading$ | async">

</app-besprechung-view>
